(function () {
  'use strict';

  // Enrich only the existing welcome form. Klaviyo retains submission,
  // validation, consent and coupon delivery.
  var selector = 'form[data-testid="klaviyo-form-Skrwmu"]';
  function syncTerms() {
    var source = document.querySelector('.FooterSignup__Terms');
    document.querySelectorAll(selector).forEach(function (form) {
      var email = form.querySelector('input[type="email"]');
      var row = email && email.closest('[data-testid="form-row"]');
      var terms = form.querySelector('[data-welcome-offer-terms]');
      if (!source || !row) {
        if (terms) terms.remove();
        return;
      }
      if (!terms) {
        terms = document.createElement('p');
        terms.setAttribute('data-welcome-offer-terms', '');
        row.parentNode.insertBefore(terms, row);
      }
      var copy = source.textContent.trim();
      if (terms.textContent !== copy) terms.textContent = copy;
    });
  }
  var observer = new MutationObserver(syncTerms);
  function start() {
    observer.observe(document.documentElement, { childList: true, subtree: true });
    syncTerms();
  }
  window.addEventListener('pagehide', function () { observer.disconnect(); });
  window.addEventListener('pageshow', start);
  start();
})();
